import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Home from './Home.js';
import FashionBazaar from './FashionBazaar.js';
import Layout from './Layout.js';

function App() {
	return (
		<div className="App">
			<Routes>
				{/* All routes that share Header + Footer */}
				<Route element={<Layout />}>
					<Route path="/" element={<Home />} />
					<Route path="/FashionBazaar" element={<FashionBazaar />} />
				</Route>
			</Routes>
		</div>
	);
}

export default App;

